import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody33.css';

import clientimg from '../images/case-study-client33.webp'
import outcome from '../images/outcome33.webp'

import sm1 from '../images/cs33so1.webp'
import sm2 from '../images/cs33so2.webp'
import sm3 from '../images/cs33so3.webp'
import sm4 from '../images/cs33so4.webp'


const Casestudybody33 = () => {

    return (
        <>
        <section className='casestudybody33-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A leading investment group that operates a diversified portfolio of investments across various sectors, including real estate, healthcare, education, hospitality, and financial services</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>Client currently holds a strategic investment in the education sector, which it intends to take public through an Initial Public Offering (IPO). To support this initiative, the client has requested a comprehensive IPO analysis focused on transactions that have occurred over the past five years</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody33-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Understanding Client Needs: </h4>
                          <p>Conducted preliminary scoping discussions to <span style={{color:"#03A393"}}>define the scope of the analysis and mapping out specific data points</span> required across financial advisors, IPO activity, and sector trends</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Compilation & Categorization: </h4>
                          <p>Collected IPO data year-wise from <span style={{color:"#03A393"}}>public sources such as company filings, ensuring comprehensive coverage of IPO listings</span> between 2019-2024. Developed a structured database capturing key metrics, including, IPO date, financial advisor, company, IPO size, percentage sold, IPO fee, and post-listing stock performance</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Reporting:</h4>
                          <p>Created yearly timeline slides, each highlighting <span style={{color:"#03A393"}}>IPO events and details</span> such as IPO performance, IPO proceeds, with details of issuers and lead financial advisors</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Advisor Analysis:</h4>
                          <p>Performed analysis on advisors showcasing details about the <span style={{color:"#03A393"}}>number and performance of IPOs</span> they handled & the sectors they deal into</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Education Sector Analysis: </h4>
                          <p>Analysed education <span style={{color:"#03A393"}}>sector-specific valuation trends, IPO proceeds, advisor role, and Post-IPO performance</span> to build a reference for future educational listings</p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Recommendation:</h4>
                          <p>Provided our recommendation based on assumed share <span style={{color:"#03A393"}}>sale and expected IPO proceeds</span>, tailored to identify suitable advisors for a USD ~2 Bn offering</p>
                        </div>
                      </div> 

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody33-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a comprehensive IPO benchmarking report with advisor mapping, sector insights, and tailored recommendations to support the group’s IPO listing strategy</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody33
